import persistReducer from "redux-persist/lib/persistReducer";
import storage from "redux-persist/lib/storage";
import { NavigationConstant } from "./NavigationConstant";

const initialState = {
    NavigationDataList: [],
    NavigationdataLoading: {
    isLoading: false,
  },


};

export const NavigationDataReducer = persistReducer(
  {
    storage,
    key: "Navigationdata",
    whitelist: ["NavigationDataList"],
  },

  (state = initialState, { type, payload }) => {
    switch (type) {
      case NavigationConstant.NAVIGATION_REQUEST: {
        return {
          ...state,
          NavigationDataList: [],
          NavigationdataLoading: {
            isLoading: true,
          },
        };
      }

      case NavigationConstant.NAVIGATION_RESPONSE: {
        return {
          ...state,
          NavigationDataList: payload,
          NavigationdataLoading: {
            isLoading: false,
          },
        };
      }

     

      default:
        return state;
    }
  }
);
